<template>
    <div>
        <vue-headful :title="'Clients ('+clientCount+') - AMOS365'" />

        <h4 class="page-header">
            Clients ({{ clientCount }})

            <router-link to="/clients/create" class="btn btn-sm btn-info" v-if="canManageClients">
                <i class="fas fa-plus-square"></i> Create
            </router-link>
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="clientsTable" url="/clients" :columns="columns" :options="options">

                    <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                    </div>

                    <div slot="afterFilter" class="ml-2">

                    </div>

                    <template slot="last_name" slot-scope="props">
                        <router-link :to="`/clients/view/${props.row.id}`">{{ props.row.last_name }}, {{ props.row.first_name }}</router-link>
                    </template>

                    <template slot="is_active" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                        <label class="badge badge-warning" v-else>Inactive</label>
                    </template>
                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                clientCount: null,
                columns: ['last_name', 'spouse_name', 'medicare', 'email', 'address', 'city', 'state_name', 'zip', 'is_active'],
                options: {
                    headings: {
                        last_name: 'Client',
                        spouse_name: 'Spouse',
                        email: 'Email',
                        address: 'Address',
                        city: 'City',
                        state_name: 'State',
                        is_active: 'Active',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'clients.last_name',
                    },
                    texts:{
                        filterPlaceholder:"Search Clients",
                    },
                    responseAdapter: (response) => {
                        //Emit the count
                        if(this.clientCount === null)
                        {
                            //Set the count
                            this.clientCount = response.data.count;
                        }
                        //this.$emit('clientListCount', response.data.count);

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },
            }
        },

        watch: {

        },

        computed: {

            canManageClients(){
                //Debugging
                //return false;

                //Check Permissions
                return this.$root.hasPermission('clients.manage');
            },
        },

        mounted() {

        }
    }
</script>
